import { nonDraggablesTypeSlide } from "@/lib/constants/slides";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { addElement } from "@/store/slideEditorSlice";
import type { TextElement } from "@ai-teach/types";
import toast from "react-hot-toast";

export const textTypeMap: Record<
  string,
  { size: { width: number; height: number }; fontSize: number; fontWeight: string }
> = {
  heading: { size: { width: 338, height: 60 }, fontSize: 48, fontWeight: "700" },
  subheading: { size: { width: 200, height: 40 }, fontSize: 32, fontWeight: "600" },
  body: { size: { width: 150, height: 30 }, fontSize: 16, fontWeight: "normal" },
};
export function useAddTextElement() {
  const dispatch = useAppDispatch();
  const { slide, canvasSize } = useAppSelector((state) => state.slideEditor.present);

  const handleAddText = (type: string) => {
    if (!slide) return;

    const slideType = slide.type;
    const knowledgeArea = slide.knowledgeArea;
    const elements = slide.elements;

    // For "word" slide type, only allow 1 text element
    if (slideType === "word") {
      const hasTextElement = elements.some((element) => element.type === "text");
      if (hasTextElement) {
        toast.error("Word slides can only have one text element", {
          id: "slide-text-limit",
        });
        return;
      }
    }

    if ((nonDraggablesTypeSlide[slideType] as readonly string[]).includes(knowledgeArea)) {
      toast.error("This slide type doesn't support custom text element", {
        id: "slide-text-limit",
      });
      return;
    }

    const config = textTypeMap[type];
    if (!config) return;

    const canvasWidth = canvasSize.height * canvasSize.aspectRatio;
    const centeredPosition = {
      x: Math.round((canvasWidth - config.size.width) / 2),
      y: Math.round((canvasSize.height - config.size.height) / 2),
    };

    dispatch(
      addElement({
        type: "text" as const,
        position: centeredPosition,
        content: "Your text...",
        size: config.size,
        style: {
          color: "#000000",
          textAlign: "center" as const,
          fontFamily: "System",
          fontStyle: "normal",
          textDecoration: "none",
          fontSize: config.fontSize,
          fontWeight: config.fontWeight,
        },
        border: {
          lineStyle: "none",
          stroke: "#000000",
          strokeWidth: 3,
          cornerRadius: 0,
        },
      } as TextElement)
    );
  };

  return { handleAddText };
}
